import Hero from "@/components/landing/Hero";
import Portfolio from "@/components/landing/Portfolio";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative overflow-x-hidden">
      <Hero />
      <Portfolio />
      <CTA />
      <Footer />
    </main>
  );
}
